@if (actions?.length > 0) {
  <div
    #actionsPanel
    [appOverlayPanel]="selectionOptionsPanel"
    [overlayPanelData]="actions"
    [overlayPanelOptions]="{ target: 'body', closeOnScroll: true }"
    data-qa="user-actions-toggle"
    class="actions-toggle"
  >
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
}

<ng-template
  #selectionOptionsPanel
  let-data
>
  <ul class="actions-list">
    @for (action of data; track action) {
      <li class="action-list-item">
        <button
          [attr.data-qa]="getQaAttribute(action)"
          (click)="performAction(action)"
          class="action-button"
        >
          <i
            [ngClass]="action.icon"
            class="action-icon theme-color"
          ></i>
          <span class="action-label">{{ action.label | translate }}</span>
        </button>
      </li>
    }
  </ul>
</ng-template>
